import { FilterParametersFieldOptionsInterface } from './field-options.interface';

export const filterParametersGetLabelForValue = <T>(field: FilterParametersFieldOptionsInterface<T, T>) =>
  field?.choices?.find((choice) => choice.value === field.value)?.label || '';
